module.exports = __webpack_public_path__ + "img/om2.417652a3.jpg";